<template>
  <div class="home-tx">
    <div class="title" @click="toTransactionListPage()">
      {{ $t("lastData.tx") }}
      <img src="../../assets/images/common/search.png" />
    </div>
    <div class="data">
      <div
        v-for="(tx, index) in listdata"
        v-bind:key="index"
        class="item click-able"
        @click="toTransactionDetailPage(tx.tx_hash)"
      >
        <div class="logo-content">
          <div class="logo">
            <div class="text">Tx</div>
          </div>
        </div>
        <div class="data-content">
          <div class="up">
            {{ tx.tx_hash.substr(0, 8) }}...{{ tx.tx_hash.substr(56) }}
          </div>
          <!-- <div>{{showtime[index]}}s ago</div> -->
          <div class="down">
            <div class="left">
              <span class="tx-type" :title="getTxtype(tx.tx_type)">
                {{ getTxtype(tx.tx_type) }}
              </span>
              <span class="tag" v-if="['209', '210', '211'].includes(tx.vm_type)"
                ><span>{{ getTxVM(tx.vm_type) }}</span></span
              >
            </div>
            <div class="right">
              <div class="time">
                {{showtime[index] &lt; 60 ? showtime[index]+'s':$HelperTools.getShowDate(showtime[index])}}
                ago
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="more click-able" @click="toTransactionListPage()">More></div> -->
  </div>
</template>

<script>
export default {
  props: {
    listdata: {
      type: Array
    }
  },
  data() {
    return {
      showtime: [0, 0, 0, 0, 0]
    };
  },
  watch: {
    listdata: function() {
      clearInterval(this.intervalBlockstandard);
      for (var i = 0; i < 5; i++) {
        this.showtime[i] = this.$HelperTools.getDateTime(
          this.listdata[i].tx_time
        );
      }
      this.intervalBlockstandard = setInterval(() => {
        for (var i = 0; i < 5; i++) {
          var time = this.showtime[i] + 1;
          this.$set(this.showtime, i, time);
        }
      }, 1000);
    }
  },
  methods: {
    toTransactionListPage() {
      if (this.$route.params.net === "testnet") {
        this.$router.push({
          name: "TransactionListTest",
          params: { pageSize: 20, pageNumber: 1, net: "testnet" }
        });
      } else {
        this.$router.push({
          name: "TransactionList",
          params: { pageSize: 20, pageNumber: 1 }
        });
      }
    },
    getTxtype: function($type) {
      switch ($type) {
        case 208:
          return "Deploy Smart Contract";
        case 209:
          return "Invoke NeoVM Contract";
        case 210:
          return "Invoke WasmVM Contract";
        case "01":
          return this.$t("transList.txType01");
        case "02":
          return this.$t("transList.txType02");
        case "03":
          return this.$t("transList.txType03");
        case "04":
          return this.$t("transList.txType04");
        case "05":
          return this.$t("transList.txType05");
        case "06":
          return this.$t("transList.txType06");
        case "07":
          return this.$t("transList.txType07");
        case "08":
          return this.$t("transList.txType08");
        case "09":
          return this.$t("transList.txType09");
        case "10":
          return this.$t("transList.txType10");
      }
    },
    getTxVM: function($type) {
      const map = {
        209: "NeoVM",
        210: "WasmVM",
        211: "EVM"
      };
      return map[$type];
    },
    toTransactionDetailPage($TxnId) {
      if (this.$route.params.net == undefined) {
        this.$router.push({
          name: "TransactionDetail",
          params: { tx_hash: $TxnId }
        });
      } else {
        this.$router.push({
          name: "TransactionDetailTest",
          params: { tx_hash: $TxnId, net: "testnet" }
        });
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.intervalBlockstandard);
  }
};
</script>

<style lang="less" scoped>
.click-able {
  cursor: pointer;
  transition: all ease 0.3s;
}
.click-able:hover {
  opacity: 0.5;
  transition: all ease 0.3s;
}
.home-tx {
  .title {
    cursor: pointer;
    position: relative;
    font-size: 16px;
    font-family: Avenir-Medium, Avenir;
    font-weight: 600;
    color: rgba(0, 0, 0, 1);
    line-height: 19px;
    transition: all ease 0.3s;
    img {
      width: 12px;
      height: 12px;
      position: absolute;
      top: 4px;
      right: 0;
    }
  }
  .title:hover {
    opacity: 0.5;
    transition: all ease 0.3s;
  }
  .data {
    padding-top: 50px;
    .item:last-child {
      margin-bottom: 0px;
      .logo-content {
        padding-bottom: 0px;
      }
      .data-content {
        padding-bottom: 0px;
        border-bottom: none;
      }
    }
    .item {
      margin-bottom: 19px;
      display: flex;
      .logo-content {
        width: 60px;
        padding-bottom: 19px;
        .logo {
          width: 40px;
          height: 40px;
          border-radius: 20px;
          background: rgba(250, 250, 250, 1);
          border: 1px solid rgba(242, 242, 242, 1);
          margin-right: 20px;
          margin-top: 2px;
          display: flex;
          align-items: center;
          justify-content: center;
          .text {
            font-size: 16px;
            font-family: Avenir, sans-serif;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.6);
            line-height: 19px;
            transform: translateY(2px);
          }
        }
      }
      .data-content {
        padding-bottom: 20px;
        border-bottom: 1px solid #fafafa;
        flex: 1;
        .up {
          font-size: 16px;
          font-family: DINPro, DINPro;
          font-weight: 500;
          color: rgba(0, 0, 0, 1);
          line-height: 21px;
        }
        .down {
          padding-top: 10px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .left {
            font-size: 12px;
            font-family: Avenir;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.3);
            line-height: 14px;
          }
          .right {
            font-size: 12px;
            font-family: Avenir;
            font-weight: 400;
            line-height: 14px;
            .txcount {
              color: rgba(0, 0, 0, 0.6);
            }
            .time {
              color: rgba(0, 0, 0, 0.3);
            }
          }
        }
      }
    }
  }
  .more {
    font-size: 14px;
    font-family: Avenir-Medium, Avenir;
    font-weight: 500;
    color: rgba(0, 0, 0, 1);
    line-height: 16px;
    text-decoration: underline;
    cursor: pointer;
  }
  .tag {
    min-width: 29px;
    height: 12px;
    line-height: 12px;
    text-align: center;
    background: #fafafa;
    border-radius: 4px;
    border: 1px solid #f2f2f2;
    display: inline-block;
    vertical-align: middle;
    margin-left: 10px;
    > span {
      font-size: 12px;
      color: #000000;
      opacity: 0.3;
      display: inline-block;
      transform: scale(0.83333333333);
      transform-origin: center;
    }
  }

  .tx-type {
    width: 110px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    vertical-align: middle;
  }
}

@media only screen and (max-width: 767px) {
  .home-tx .tag {
    margin-left: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/tx.vue